import React, { useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  Grid,
  Paper,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Home() {
  const navigate = useNavigate();
  const { user, org, loading } = useAuth();

  useEffect(() => {
    // Only redirect if we're done loading and there's an org
    if (org) {
      navigate('/login');
    }
  }, [org, navigate]);

  // Show loading state if auth is still being checked
  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }


  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Paper elevation={0} sx={{ p: 4, textAlign: 'center', bgcolor: 'transparent' }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Welcome to Your Loyalty Portal
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Track your coins, redeem rewards, and more.
          </Typography>

          {!user && (
            <Button
              variant="contained"
              size="large"
              sx={{ mt: 2 }}
              onClick={() => navigate('/login')}
            >
              Get Started
            </Button>
          )}

          {user && (
            <Button
              variant="contained"
              size="large"
              sx={{ mt: 2 }}
              onClick={() => navigate('/memberships')}
            >
              Go to Memberships
            </Button>
          )}
        </Paper>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant="h4" gutterBottom textAlign="center" sx={{ mb: 4 }}>
          Why Join Our Loyalty Program?
        </Typography>

        <Grid container spacing={4}>
          <Grid item size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  Earn Coins
                </Typography>
                <Typography variant="body1">
                  Earn coins with every purchase. The more you shop, the more you earn.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  Exclusive Rewards
                </Typography>
                <Typography variant="body1">
                  Redeem your coins for exclusive rewards, discounts, and special offers.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" component="div" gutterBottom>
                  Centralized Management
                </Typography>
                <Typography variant="body1">
                  Control all your loyalty programs in one place. No more juggling multiple cards.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Home;